class MinicartPopup extends HTMLElement {
    constructor() {
      super();
      
      this.threshold = parseInt(this.dataset.threshold) || 59900;
      this.collectionHandle = this.dataset.collectionHandle || 'acao-bolsa-linho';
      this.productId = this.dataset.productId;
      
      this.closeButton = this.querySelector('.minicart-popup__close');
      this.form = this.querySelector('.minicart-popup__form');
      
      // Only check if popup was manually closed
      this.hasBeenClosed = sessionStorage.getItem('minicart-popup-closed') === 'true';
      
      console.log('MinicartPopup initialized:', {
        threshold: this.threshold,
        collectionHandle: this.collectionHandle,
        productId: this.productId,
        hasBeenClosed: this.hasBeenClosed
      });
      
      this.bindEvents();
    }
  
    connectedCallback() {
      document.addEventListener('cart:updated', this.checkAndShow.bind(this));
      
      setTimeout(() => {
        this.checkAndShow();
      }, 1000);
    }
  
    bindEvents() {
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => {
          // Only set session storage when manually closed
          sessionStorage.setItem('minicart-popup-closed', 'true');
          this.hasBeenClosed = true;
          this.hide();
        });
      }
      
      if (this.form) {
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }

      // Close on Escape key
      this.addEventListener('keyup', (event) => {
        if (event.code?.toUpperCase() === 'ESCAPE') {
          // Also set session storage when closed with ESC
          sessionStorage.setItem('minicart-popup-closed', 'true');
          this.hasBeenClosed = true;
          this.hide();
        }
      });
    }
  
    async checkAndShow() {
      console.log('checkAndShow called, hasBeenClosed:', this.hasBeenClosed);
      
      // Don't show if manually closed in this session
      if (this.hasBeenClosed) {
        console.log('Popup was manually closed this session, skipping');
        return;
      }
      
      try {
        // Fetch current cart
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        console.log('Cart data:', cart);
        console.log('Cart total:', cart.total_price);
        console.log('Threshold:', this.threshold);
        
        // Check if popup product is already in cart
        const popupProductInCart = cart.items.some(item => 
          item.product_id.toString() === this.productId.toString()
        );

        if (popupProductInCart) {
          console.log('Popup product already in cart, hiding');
          this.hide();
          return;
        }
        
        // Show popup if cart total is above threshold and popup product not in cart
        if (cart.total_price >= this.threshold) {
          console.log('Cart total above threshold, showing popup');
          this.show();
        } else {
          console.log('Cart total below threshold, hiding popup');
          this.hide();
        }
      } catch (error) {
        console.error('Error checking cart for minicart popup:', error);
      }
    }
  
    show() {
      this.setAttribute('open', '');
    }
  
    hide() {
      this.removeAttribute('open');
    }
  
    async handleSubmit(event) {
      event.preventDefault();
      
      const formData = new FormData(this.form);
      const variantId = formData.get('id');
      const discountPercentage = parseInt(this.dataset.discountPercentage || 50);
      
      const originalPriceElement = this.querySelector('.minicart-popup__product-full-price');
      const discountedPriceElement = this.querySelector('.minicart-popup__product-discount-price');
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: {
              '_discount_percentage': discountPercentage,
              '_original_price': originalPriceElement.textContent.trim(),
              '_final_price': discountedPriceElement.textContent.trim()
            }
          }),
        });
        
        if (response.ok) {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            const sectionsResponse = await fetch('/cart?view=drawer');
            const sectionsHtml = await sectionsResponse.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(sectionsHtml, 'text/html');
            const cartContents = doc.getElementById('CartDrawer-Body').innerHTML;
            
            document.getElementById('CartDrawer-Body').innerHTML = cartContents;
            document.dispatchEvent(new CustomEvent('cart:updated'));
            this.hide();
          } else {
            document.dispatchEvent(new CustomEvent('cart:updated'));
            this.hide();
          }
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Error adding product to cart:', error);
        alert('Erro ao adicionar produto ao carrinho. Por favor, tente novamente.');
      }
    }
  
    trapFocus() {
      const focusableElements = this.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      
      if (focusableElements.length === 0) return;
      
      this.firstFocusableElement = focusableElements[0];
      this.lastFocusableElement = focusableElements[focusableElements.length - 1];
      
      this.firstFocusableElement.focus();
      
      this.focusTrap = (event) => {
        if (event.key !== 'Tab') return;
        
        if (event.shiftKey) {
          if (document.activeElement === this.firstFocusableElement) {
            this.lastFocusableElement.focus();
            event.preventDefault();
          }
        } else {
          if (document.activeElement === this.lastFocusableElement) {
            this.firstFocusableElement.focus();
            event.preventDefault();
          }
        }
      };
      
      this.addEventListener('keydown', this.focusTrap);
    }
  
    restoreFocus() {
      if (this.focusTrap) {
        this.removeEventListener('keydown', this.focusTrap);
      }
    }
}

customElements.define('ec-minicart-popup', MinicartPopup);